'use client';
import { useTimePilotT } from "@/i18n/useTimePilotT";

import * as React from 'react';
import { useState } from 'react';
import dynamic from 'next/dynamic';
import { ListIcon, CopyIcon, TrashIcon, NotePencilIcon } from "@phosphor-icons/react";
import { Button } from '@tranquility-ai/theme-components/button';

const ActionsDeleteEventModal = dynamic(
  () => import('./actions-delete-event-modal').then((m) => m.ActionsDeleteEventModal),
  { ssr: false, loading: () => null },
);

export const actionsOptions = [ undefined, 'awaiting', 'approved', 'rejected'];
const iconClass = 'p-0 m-0 text-white/65 hover:text-brand-blue-light hover:cursor-pointer';
const ACTION_ITEMS = [
  { id: 'Edit Event', labelKey: 'presentation.editEvent' },
  { id: 'Duplicate Event', labelKey: 'viewers.duplicateEvent' },
  { id: 'Delete Event', labelKey: 'viewers.deleteEvent' },
] as const;

const Actions = React.memo((props: { handleRowActions: (id: number, action: string) => void, data: any }) => {
  const t = useTimePilotT();
  const [isOpen, setIsOpen] = useState(false);
  const [deleteModalKey, setDeleteModalKey] = useState<number | null>(null);
  const { handleRowActions, data } = props;

  const handleClick = (action: string) => {
    if (action === 'Delete Event') {
      setDeleteModalKey(data.displayOrder);
    } else {
      handleRowActions(data.displayOrder, action);
    }
  };

  return (
    <div aria-label={t("viewers.actionsColumn")} className={`flex justify-center items-center pt-[3px]`} onMouseEnter={() => setIsOpen(true)} onMouseLeave={() => setIsOpen(false)}>
      {deleteModalKey !== null && (
        <ActionsDeleteEventModal
          displayOrder={deleteModalKey}
          onCancel={() => setDeleteModalKey(null)}
          onConfirm={() => {
            handleRowActions(deleteModalKey, 'Delete Event');
            setDeleteModalKey(null);
          }}
        />
      )}
      {!isOpen && <ListIcon size={22} aria-label={t("viewers.showActionsMenu")} />}
      {isOpen && <div className='flex justify-center w-[80px] h-[80px]'>
        <div aria-label={t("userManagement.actions")} className='flex flex-col ml-[-5px]'>
          {ACTION_ITEMS.map((action) => (
            <Button
              iconOnly
              size="sm"
              style="text"
              color="light"
              background="inverse"
              aria-label={t(action.labelKey)}
              key={action.id}
              onClick={() => handleClick(action.id)}
              className="border-0"
            >
              {action.id === 'Edit Event' ? <NotePencilIcon size={22} className={iconClass} /> : null}
              {action.id === 'Duplicate Event' ? <CopyIcon size={22} className={iconClass} /> : null}
              {action.id === 'Delete Event' ? <TrashIcon size={22} className={iconClass} /> : null}
            </Button>
          ))}
        </div>
      </div>}
    </div>
  );
});

Actions.displayName = 'Actions';

export default Actions;
